module.exports = __webpack_public_path__ + "res/img_back.54a6a2a6ae0f8769c69f622095f64842.png";